(() => {
  if (window.C2BShippingEstimatorLoaded === true) {
    return;
  }

  window.C2BShippingEstimatorLoaded = true;

  const ROOT_SELECTOR = '[data-c2b-shipping-estimator]';
  const READY_ATTR = 'c2bShippingEstimatorReady';

  const PROFILE_LABELS = {
    general_profile: 'curier',
    house_nordic: 'House Nordic',
    kooduu: 'Kooduu',
    flonal: 'Flonal',
  };

  const CURRENCY = 'RON';

  const FLONAL_RANGES = [
    { min: 0, max: 127500, price: 30000, label: '0-1.275,00 lei' },
    { min: 127501, max: 178500, price: 40800, label: '1.275,01-1.785,00 lei' },
    { min: 178501, max: 229400, price: 51000, label: '1.785,01-2.294,00 lei' },
    { min: 229401, max: 280300, price: 63700, label: '2.294,01-2.803,00 lei' },
    { min: 280301, max: 331300, price: 76400, label: '2.803,01-3.313,00 lei' },
  ];
  const DENMARK_FURNITURE_RANGES = [
    { min: 0, max: 30000, price: 21300, label: '0-30 kg' },
    { min: 30001, max: 50000, price: 130000, label: '30,01-50 kg' },
    { min: 50001, max: 75000, price: 170000, label: '50,01-75 kg' },
    { min: 75001, max: 100000, price: 185000, label: '75,01-100 kg' },
    { min: 100001, max: 150000, price: 190000, label: '100,01-150 kg' },
    { min: 150001, max: 200000, price: 220000, label: '150,01-200 kg' },
    { min: 200001, max: Infinity, price: 315000, label: 'peste 200 kg' },
  ];

  const cssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const moneyFormatter = new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const compactNumberFormatter = new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const formatMoney = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

  const formatWeight = (weightKg) => {
    const value = Number(weightKg);

    if (!Number.isFinite(value) || value <= 0) {
      return '';
    }

    return `${compactNumberFormatter.format(value)} kg`;
  };

  const formatQuantity = (quantity) => `${quantity} buc.`;

  const getQuantity = (root) => {
    const formId = root.dataset.formId;
    const sectionId = root.dataset.sectionId;
    const escapedFormId = formId ? cssEscape(formId) : '';

    const input =
      (escapedFormId && document.querySelector(`input[name="quantity"][form="${escapedFormId}"]`)) ||
      (sectionId && document.getElementById(`Quantity-${sectionId}`)) ||
      root.closest('product-info')?.querySelector('quantity-input input[name="quantity"]') ||
      document.querySelector('quantity-input input[name="quantity"]');

    const value = Number.parseInt(input?.value, 10);

    if (!Number.isFinite(value) || value < 1) {
      return 1;
    }

    return value;
  };

  const getCurrentVariantId = (root) => {
    const formId = root.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const input =
      form?.querySelector('input.product-variant-id[name="id"]') ||
      root.closest('product-info')?.querySelector('input.product-variant-id[name="id"]') ||
      document.querySelector('input.product-variant-id[name="id"]');

    const value = Number.parseInt(input?.value, 10);

    return Number.isFinite(value) ? value : null;
  };

  const parseJsonFromScript = (root, selector, fallback) => {
    const script = root.querySelector(selector);

    if (!script?.textContent) {
      return fallback;
    }

    try {
      const parsed = JSON.parse(script.textContent);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      console.warn('[C2B shipping estimator] Could not parse JSON data.', error);
      return fallback;
    }
  };

  const parseVariants = (root) => {
    const parsed = parseJsonFromScript(root, '[data-c2b-shipping-estimator-variants]', []);
    return Array.isArray(parsed) ? parsed : [];
  };

  const parseCartItems = (root) => {
    const parsed = parseJsonFromScript(root, '[data-c2b-shipping-estimator-cart-items]', []);
    return Array.isArray(parsed) ? parsed : [];
  };

  const getRange = (value, ranges) => ranges.find((item) => value >= item.min && value <= item.max) || null;

  const getDenmarkFurnitureRange = (weightGrams) => getRange(weightGrams, DENMARK_FURNITURE_RANGES);

  const getGeneralRange = (weightKg) => {
    if (weightKg <= 1) return { price: 3000, label: '0-1 kg' };
    if (weightKg <= 5) return { price: 4000, label: '1,01-5 kg' };
    if (weightKg <= 10) return { price: 5500, label: '5,01-10 kg' };
    if (weightKg <= 20) return { price: 8500, label: '10,01-20 kg' };
    if (weightKg <= 30) return { price: 12000, label: '20,01-30 kg' };

    if (weightKg <= 60) {
      const chargedKg = Math.ceil(weightKg);
      return {
        price: chargedKg * 400,
        label: `${compactNumberFormatter.format(chargedKg - 1)},01-${compactNumberFormatter.format(chargedKg)} kg`,
      };
    }

    return null;
  };

  const buildWeightDetails = () => [];

  const estimateShipping = ({ profileKey, quantity, totalWeightGrams, totalWeightKg, totalCents }) => {
    if (profileKey === 'house_nordic') {
      const denmarkFurnitureRange = getDenmarkFurnitureRange(totalWeightGrams);

      if (!denmarkFurnitureRange) {
        return {
          status: 'unknown',
          label: PROFILE_LABELS.house_nordic,
          value: 'Nu poate fi estimat',
          details: buildWeightDetails({
            quantity,
            totalWeightKg,
          }),
          note: 'Nu există o regulă de transport acoperită pentru această configurație. Costul final se confirmă în checkout.',
        };
      }

      return {
        status: 'available',
        label: PROFILE_LABELS.house_nordic,
        cents: denmarkFurnitureRange.price,
        rangeLabel: denmarkFurnitureRange.label,
        details: buildWeightDetails({
          quantity,
          totalWeightKg,
        }),
        note: 'Costul final se confirmă în checkout.',
      };
    }

    if (profileKey === 'kooduu') {
      return {
        status: 'available',
        label: PROFILE_LABELS.kooduu,
        cents: 10000,
        details: [],
        note: 'Costul final se confirmă în checkout.',
      };
    }

    if (profileKey === 'flonal') {
      const flonalRange = getRange(totalCents, FLONAL_RANGES);

      if (!flonalRange) {
        return {
          status: 'unknown',
          label: PROFILE_LABELS.flonal,
          value: 'Nu poate fi estimat',
          details: [],
          note: 'Pentru această valoare, transportul nu poate fi estimat automat. Costul final se confirmă în checkout.',
        };
      }

      return {
        status: 'available',
        label: PROFILE_LABELS.flonal,
        cents: flonalRange.price,
        rangeLabel: flonalRange.label,
        details: [],
        note: 'Costul final se confirmă în checkout.',
      };
    }

    const generalRange = getGeneralRange(totalWeightKg);

    if (!generalRange) {
      return {
        status: 'unknown',
        label: PROFILE_LABELS.general_profile,
        value: 'Nu poate fi estimat',
        details: buildWeightDetails({
          quantity,
          totalWeightKg,
        }),
        note: 'Nu există o regulă de transport acoperită pentru această configurație. Costul final se confirmă în checkout.',
      };
    }

    return {
      status: 'available',
      label: PROFILE_LABELS.general_profile,
      cents: generalRange.price,
      rangeLabel: generalRange.label,
      details: buildWeightDetails({
        quantity,
        totalWeightKg,
      }),
      note: 'Costul final se confirmă în checkout.',
    };
  };

  const getCartGroup = (groups, profileKey) => {
    if (!groups[profileKey]) {
      groups[profileKey] = {
        profileKey,
        quantity: 0,
        totalWeightGrams: 0,
        totalCents: 0,
      };
    }

    return groups[profileKey];
  };

  const buildCartGroups = (items) => {
    const groups = {};

    items.forEach((item) => {
      const quantity = Number.parseInt(item.quantity, 10);
      if (!Number.isFinite(quantity) || quantity < 1) return;

      const profileKey = item.profileKey || 'general_profile';
      const weightGrams = Number(item.weightGrams) || 0;
      const linePriceCents = Number(item.linePriceCents) || 0;
      const group = getCartGroup(groups, profileKey);

      group.quantity += quantity;
      group.totalWeightGrams += weightGrams * quantity;
      group.totalCents += linePriceCents;
    });

    return Object.values(groups);
  };

  const buildCartDetail = (group, result) => {
    const rawLabel = result.label || PROFILE_LABELS[group.profileKey] || PROFILE_LABELS.general_profile;
    const label = String(rawLabel).trim();
    const transportLabel = label.toLowerCase().startsWith('transport ') ? label : `Transport ${label}`;
    const price = result.cents != null ? formatMoney(result.cents) : result.value || 'Nu poate fi estimat';

    return `${transportLabel} - ${price}`;
  };

  const estimateCartShipping = (items) => {
    const groups = buildCartGroups(items);

    if (groups.length === 0) {
      return {
        status: 'unknown',
        value: 'Nu poate fi estimat',
        details: [],
        note: 'Coșul este gol sau nu conține produse cu transport calculabil.',
      };
    }

    let totalCents = 0;
    let hasUnknown = false;
    const details = [];

    groups.forEach((group) => {
      const result = estimateShipping({
        profileKey: group.profileKey,
        quantity: group.quantity,
        totalWeightGrams: group.totalWeightGrams,
        totalWeightKg: group.totalWeightGrams / 1000,
        totalCents: group.totalCents,
      });

      if (result.cents == null) {
        hasUnknown = true;
      } else {
        totalCents += result.cents;
      }

      details.push(buildCartDetail(group, result));
    });

    if (hasUnknown) {
      return {
        status: 'unknown',
        value: 'Nu poate fi estimat',
        details,
        note: 'Una sau mai multe reguli de transport nu sunt acoperite de estimator. Costul final se confirmă în checkout.',
      };
    }

    return {
      status: 'available',
      cents: totalCents,
      details,
      note: 'Costul final se confirmă în checkout.',
    };
  };

  const setState = (root, result) => {
    const valueNode = root.querySelector('[data-c2b-shipping-estimator-value]');
    const detailsNode = root.querySelector('[data-c2b-shipping-estimator-details]');
    const noteNode = root.querySelector('[data-c2b-shipping-estimator-note]');

    root.dataset.c2bShippingEstimatorStatus = result.status;

    if (valueNode) {
      valueNode.textContent = result.cents != null ? formatMoney(result.cents) : result.value || 'Nu poate fi estimat';
    }

    if (detailsNode) {
      const details = Array.isArray(result.details) ? result.details.filter(Boolean) : [];
      detailsNode.innerHTML = '';

      if (details.length > 0) {
        details.forEach((detail) => {
          const item = document.createElement('li');
          item.textContent = detail;
          detailsNode.appendChild(item);
        });

        detailsNode.hidden = false;
      } else {
        detailsNode.hidden = true;
      }
    }

    if (noteNode) {
      noteNode.textContent = result.note || 'Costul final se confirmă în checkout.';
    }
  };

  const updateProduct = (root) => {
    const variants = parseVariants(root);
    const variantId = getCurrentVariantId(root);
    const variant = variants.find((item) => Number(item.id) === variantId) || variants[0];

    if (!variant) {
      setState(root, {
        status: 'unknown',
        value: 'Nu poate fi estimat',
        note: 'Nu am putut identifica varianta selectată.',
      });
      return;
    }

    const quantity = getQuantity(root);
    const weightGrams = Number(variant.weightGrams) || 0;
    const priceCents = Number(variant.priceCents) || 0;
    const totalWeightGrams = weightGrams * quantity;
    const totalWeightKg = totalWeightGrams / 1000;
    const totalCents = priceCents * quantity;
    const profileKey = root.dataset.profileKey || 'general_profile';

    setState(root, estimateShipping({ profileKey, quantity, totalWeightGrams, totalWeightKg, totalCents }));
  };

  const updateCart = (root) => {
    const items = parseCartItems(root);
    setState(root, estimateCartShipping(items));
  };

  const update = (root) => {
    const mode = root.dataset.c2bShippingEstimatorMode || root.dataset.mode || 'product';

    if (mode === 'cart') {
      updateCart(root);
      return;
    }

    updateProduct(root);
  };

  const scheduleUpdate = (root) => {
    window.requestAnimationFrame(() => update(root));
  };

  const init = (root) => {
    if (!root || root.dataset[READY_ATTR] === 'true') {
      return;
    }

    root.dataset[READY_ATTR] = 'true';
    scheduleUpdate(root);
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  const scheduleAllUpdates = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(scheduleUpdate);
  };

  const observeDynamicRoots = () => {
    if (!window.MutationObserver || !document.documentElement) return;

    let queued = false;

    const observer = new MutationObserver((mutations) => {
      const hasEstimatorMutation = mutations.some((mutation) =>
        Array.from(mutation.addedNodes || []).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(ROOT_SELECTOR) || node.querySelector?.(ROOT_SELECTOR))
        )
      );

      if (!hasEstimatorMutation || queued) return;

      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        initAll();
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('input', (event) => {
    if (!event.target.matches('input[name="quantity"], input[name="updates[]"]')) return;

    scheduleAllUpdates();
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input, select')) return;

    scheduleAllUpdates();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('quantity-input .quantity__button, cart-remove-button')) return;

    window.setTimeout(scheduleAllUpdates, 0);
  });

  observeDynamicRoots();

  if (document.readyState !== 'loading') {
    initAll();
  }
})();
